import { Precise } from "../math/precise";

/**
 * SafeMath is a class that provides safe mathematical operations
 * that avoid floating point precision issues
 */
export class SafeMath {
  /**
   * Safe division of two numbers (without floating point precision issues)
   */
  static divide(a: number | string, b: number | string) {
    const strA = a.toString();
    const strB = b.toString();
    return Number(Precise.stringDiv(strA, strB));
  }

  /**
   * Safe multiplication of two numbers (without floating point precision issues)
   */
  static multiply(a: number | string, b: number | string) {
    const strA = a.toString();
    const strB = b.toString();
    return Number(Precise.stringMul(strA, strB));
  }
}
